import React, { useEffect, useState } from 'react'
import BusinessStyles from './EditProduct.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'

const EditProduct = () => {

  
const name=useSelector((state)=>state.globalData.name);
const count=useSelector((state)=>state.globalData.notificationCount);
const dispatch=useDispatch();


  const location = useLocation()
  const data = location.state
  console.log(data)

  const navigate = useNavigate()

  const inputRef = React.useRef();

  const [file, setFile] = useState(null)
  const [source, setSource] = React.useState();
  const [fileName, setFileName] = React.useState('');
  const [imageSelect, setImageSelect] = useState(false)

  const [portalName, setportalName] = useState('')
  const [portalDescription, setportalDescription] = useState('')
  const [portalLink, setportalLink] = useState('')

  useEffect(() => {
    if (data) {
      setportalName(data.portal.portalName)
      setportalDescription(data.portal.portalDescription)
      setportalLink(data.portal.portalLink)
    }
  }, [data])


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file.name)
    const url = URL.createObjectURL(file);
    setSource(url);
    setImageSelect(true)
    setFile(file)
  };

  const handleChoose = (event) => {
    inputRef.current.click();
  };

  const discardImage = (event) => {
    setSource(null)
    setFileName('')
    setFile(null)
    inputRef.current.value = ""
    setImageSelect(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formDataObj = new FormData()
    formDataObj.append("file", file)
    formDataObj.append("portalName", portalName)
    formDataObj.append("portalDescription", portalDescription)
    formDataObj.append("portalLink", portalLink)

    try {
      const imageResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/mainportal/updatePortalImage/${data.imgId}`,
        formDataObj,
        {
          headers: {
            "Content-Type": "image/jpeg"
          }
        }
      )
      console.log(imageResponse)
    } catch (error) {
      console.error(error)
    }
      try {
      const businessResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/mainportal/updatePortalDetails/${data.portal.portalId}`,
        {portalName, portalDescription, portalLink},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      // console.log('Business Updated.')
      // console.log(businessResponse)
      
    } catch (error) {
      console.error(error)
    }
    alert('Business Updated.')

      dispatch(fetchNotifications())

      dispatch(setNotificationCount({
        count:count+1,
       }))
      discardImage()
      navigate('/productpage')
  }


    useEffect(() => {
    const fetchImage = async () => {
      try {
        const imageResponse = await axios.get(
          `${process.env.REACT_APP_STEELADMIN}/mainportal/file/${data.portalImageName}`
        );
        console.log(imageResponse);
        setSource(imageResponse);
      } catch (error) {
        console.error(error);
      }
    };

    fetchImage();
  }, [data.newBusinessImageName]);


  return (
    <div className={BusinessStyles.businessMain}>
      <div className={BusinessStyles.businessContent}>
        <form action="" className={BusinessStyles.businessForm} onSubmit={handleSubmit} encType='multipart/form-data'>
          <label className={BusinessStyles.businessFormLabel}>Title</label>
          <input className={BusinessStyles.businessFormText} type="text" value={portalName} name='portalName' onChange={(event) => setportalName(event.target.value)} />
          <label className={BusinessStyles.businessFormLabel}>Description</label>
          <textarea className={BusinessStyles.businessFormDesc} value={portalDescription} name='portalDescription' onChange={(event) => setportalDescription(event.target.value)} />
          <label className={BusinessStyles.businessFormLabel}>Link</label>
          <input className={BusinessStyles.businessFormText} type="text" value={portalLink} name='portalLink' onChange={(event) => setportalLink(event.target.value)} />
          <label className={BusinessStyles.businessFormLabel}>Upload</label>
          <div className={BusinessStyles.ImgInput}>
            <input
              ref={inputRef}
              className={BusinessStyles.ImgInput_input}
              type="file"
              onChange={handleFileChange}
            />
            {!source && <button type='button' onClick={handleChoose}>Browse</button>}
            {source && (
              <img
                className={BusinessStyles.ImgInput_img}
                width="100%"
                src={`${process.env.REACT_APP_STEELADMIN}/mainportal/file/${data.portalImageName}`}
                alt='uploadedimage'
              />
              )}
              </div>
            <div className={BusinessStyles.ImgInput_footer}>
              {imageSelect ?
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                  {fileName}
                </div> :
                ''}
                <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
            </div>
          <Button variant='contained' type='submit' className={BusinessStyles.saveChanges}>Save changes</Button>
        </form>
      </div>
    </div>
  )
}

export default EditProduct